export default "__VITE_ASSET__cc9908be__"